import jwtDecode from "jwt-decode";
import axios from "axios";
import { useAuth } from "../store/useAuth";
import { LOG } from "../utils/logUtil";

type DecodedJwtProps = {
  exp: number;
};

export const AuthService = {
  isTokenExpired: (token: string) => {
    try {
      const decodedToken: DecodedJwtProps = jwtDecode(token);
      const isExpired =
        new Date(decodedToken.exp * 1000).getTime() < Date.now();

      return isExpired;
    } catch (error) {
      LOG.error("AuthService.isTokenExpired:", { error });
      return false;
    }
  },
  refreshToken: async (refreshToken: string) => {
    try {
      const body = {
        refreshToken,
      };
      axios.defaults.headers.common.Authorization = "";
      const refreshTokenResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/login/refreshToken`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      const refreshTokenResponseJson = await refreshTokenResponse.json();

      if (refreshTokenResponseJson?.accessToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${refreshTokenResponseJson?.accessToken}`;
        return refreshTokenResponseJson;
      } else {
        useAuth.getState().logout();
      }
    } catch (error) {
      LOG.error("Error on refreshAccessToken", { error });
      useAuth.getState().logout();
    }
  },
};
